import { useState } from 'react'
import millify from 'millify'
import "./postActions.styles.css"
import { createReaction, deleteReaction } from '../../services/ideas.service'
import likeIcon from '../../assets/images/star-hand-thumbs-up.svg'
import dislikeIcon from '../../assets/images/star-hand-thumbs-down.svg'
import chatIcon from '../../assets/images/star-chat-dots.svg'
export const PostActions = ({ ideaId, hearts, likes, dislikes, comments, toggleComments, reactionId, reactionType }) => {
    const [reaction, setReaction] = useState(reactionType)
    const [heartsCount, setHeartsCount] = useState(hearts)
    const [likesCount, setLikesCount] = useState(likes)
    const [dislikeCount, setDislikeCounts] = useState(dislikes)

    const changeReaction = async action => {
        if (action === reaction) {
            setReaction("")
            deleteReaction(reactionId)
            decreaseReaction(reaction)
        }
        else {
            await createReaction(reactionId, ideaId, action)
            setReaction(action)
            decreaseReaction(reaction)
            increaseReaction(action)
        }
    }

    const increaseReaction = (action,) => {
        switch (action) {
            case 'heart':
                setHeartsCount(heartsCount + 1)
                break;
            case 'like':
                setLikesCount(likesCount + 1)
                break;
            case 'dislike':
                setDislikeCounts(dislikeCount + 1)
                break
            default:
                break
        }
    }

    const decreaseReaction = (action) => {
        switch (action) {
            case 'heart':
                setHeartsCount(heartsCount - 1)
                break;
            case 'like':
                setLikesCount(likesCount - 1)
                break;
            case 'dislike':
                setDislikeCounts(dislikeCount - 1)
                break
            default:
                break
        }
    }

    return (
        <>
         <div className="col-lg-1">
            <div className="card rounded-10">
                <div className="card-body text-center d-flex d-lg-block px-5">
                    <p className="line-height-10 mb-0 w-25 w-lg-100">
                        <i className={`fas fa-heart ${reaction == 'heart' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction("heart")} />
                        <br />
                        <span className="font-lato font-10 opacity-50">{millify(heartsCount)}</span>
                    </p>
                    <hr className="my-5 opacity-50 w-50 d-none d-lg-block" />
                    <span className="vr d-lg-none" />
                    <p className="line-height-10 mb-0 w-25 w-lg-100">
                        <i className={`fas fa-thumbs-up ${reaction == 'like' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction('like')}/>
                        <br />
                        <span className="font-lato font-10 opacity-50">{millify(likesCount)}</span>
                    </p>
                    <hr className="my-5 opacity-50 w-50 d-none d-lg-block" />
                    <span className="vr d-lg-none" />
                    <p className="line-height-10 mb-0 w-25 w-lg-100">
                        <i className={`fas fa-thumbs-down ${reaction == 'dislike' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction("dislike")}/>
                        <br />
                        <span className="font-lato font-10 opacity-50">{millify(dislikeCount)}</span>
                    </p>
                    <hr className="my-5 opacity-50 w-50 d-none d-lg-block" />
                    <span className="vr d-lg-none" />
                    <p className="line-height-10 mb-0 w-25 w-lg-100">
                        <i className="fas fa-comment-dots opacity-50" style={{ cursor: 'pointer' }} onClick={toggleComments}/>
                        <br />
                        <span className="font-lato font-10 opacity-50">{millify(comments)}</span>
                    </p>
                </div>
            </div>
        </div>
        </>
    )
}